import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import * as z from "zod/v4";

const ImageSchema = z.object({
  id: z.string(),
  url: z.string(),
  alt_text: z.string(),
  position: z.number(),
});

const ProductPriceSchema = z.object({
  productId: productIdFormat.schema,
  price: z.number(),
  currency: z.string(),
});

export const updateProductFamily = {
  name: "updateProductFamily" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    title: z.string().optional(),
    description: z.string().optional(),
    vendor: z.string().nullable().optional(),
    tags: z.array(z.string()).optional(),
    attributes: z.array(AttributeSchema).optional(),
    images: z.array(ImageSchema).optional(),
    productPrices: z.array(ProductPriceSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
